import { VARIATION_FORM_MESSAGES, VariationFormMessages } from "./variations-form.messages";
import { VARIATION_STATUS_MESSAGES, VariationStatusMessages } from "./variations-status.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type VariationFormPageMessages = ActionButtonMessages &
  VariationFormMessages &
  SidebarMessages &
  VariationStatusMessages & {
    editPageTitle: string;
    createPageTitle: string;
    cardTitle: string;
    breadCrumbTitle: string;
    categorySectionTitle: string;
  };

export const VARIATION_FORM_PAGE_MESSAGES: VariationFormPageMessages = {
  // Page titles
  breadCrumbTitle: "Variações",
  editPageTitle: "Detalhes da Variação",
  createPageTitle: "Criar Variação",
  cardTitle: "Nova Variação",
  categorySectionTitle: "Categoria do site",

  ...VARIATION_STATUS_MESSAGES,
  ...VARIATION_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};

export default VARIATION_FORM_MESSAGES;
